<template>
  <div class="system-detail">
    <!-- banner -->
    <div class="carousel_wrap">
      <el-carousel height="37vw" loop arrow="never" class="hidden-xs-only">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.img" alt="" class="img_item" loading="lazy" />
          <div class="tips_font">
            <h1>{{ item.line1 || "" }}</h1>
            <h1>{{ item.line2 || "" }}</h1>
          </div>
        </el-carousel-item>
      </el-carousel>
      <el-carousel height="50vw" loop arrow="never" class="hidden-sm-and-up">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.img" alt="" class="img_item" loading="lazy" />
          <div class="tips_font">
            <h1>{{ item.line1 || "" }}</h1>
            <h1>{{ item.line2 || "" }}</h1>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="system-detail-container">
      <h2>{{ title1 }}</h2>
      <h3>{{ title2 }}</h3>
      <div class="system-list">
        <div
          v-for="(item, index) in imageList"
          :key="index"
          class="system-list_item"
        >
          <img :src="item" loading="lazy" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customerTypeIndex: 0,
      customerIndex: 0,
      imageList: [],
      title1: "",
      title2: "",
      bannerList: []
    }
  },
  created() {
    console.log("customer detail created")
    let { customerTypeIndex, customerIndex } = this.$route.query;
    this.customerTypeIndex = customerTypeIndex + ""
    this.customerIndex = Number(customerIndex)
    this.initData()
  },
  methods: {
    initData() {
      const baseUrl = process.env.NODE_ENV === 'production'
        ? process.env.VUE_APP_PUBLIC_PATH
        : '/'

      fetch(baseUrl + '/system/data.json')
        .then(response => response.json())
        .then(data => {
          let { banners, systems } = data
          this.bannerList = banners
          this.title1 = systems[this.customerTypeIndex].name
          this.title2 = systems[this.customerTypeIndex].list[this.customerIndex].name
          this.imageList = systems[this.customerTypeIndex].list[this.customerIndex].imageList
          console.log(this.imageList, this.customerTypeIndex, this.customerIndex, this.title1, this.title2, "*******************88")
        })
        .catch(error => console.error('Error loading JSON:', error));
    },
  }
}
</script>
<style lang="scss" scoped>
.carousel_wrap {
  position: relative;
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .tips_font {
    position: absolute;
    top: 260px;
    left: 300px;
    z-index: 5;
    color: #fff;
    font-size: 25px;
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
}

.system-detail {
  width: 100%;
  .system-detail-container {
    width: 80%;
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    align-items: center;
    h2 {
      font-size: 28px;
    }
    h3 {
      margin-top: 30px;
      font-size: 24px;
    }
  }
}
.system-list {
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  justify-content: left;
  margin-top: 50px;
  .system-list_item {
    width: 300px;
    height: 400px;
    display: flex;
    flex-direction: column;
    margin-right: 20px;
    margin-bottom: 20px;
    font-size: 24px;
    text-align: center;
    > img {
      width: 100%;
      height: 80%;
      object-fit: contain;
    }
  }
}
</style>